import {
  FC,
  ImgHTMLAttributes
} from "react";
import NcImageDefault from "./NcImageDefault";

export interface NcImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  containerClassName?: string;
}

const NcImage: FC<NcImageProps> = ({
  containerClassName = "",
  alt = "nc-imgs",
  src = "",
  className = "object-cover w-full h-full",
  ...args
}) => {
  return <NcImageDefault {...{ containerClassName, alt, src:src?.replace('https://adboard-booking-cdn.mos.ap-southeast-2.sufybkt.com','https://adboard-booking-cdn.mos.ap-southeast-2.sufybkt.com'), className, ...args }} />;
};

export default NcImage;
